const endpoint = process.env.REACT_APP_ENDPOINT
  ? process.env.REACT_APP_ENDPOINT
  : "";
//export const URL = 'http://192.168.1.101/fleet_review/api/web';
export const URL = 'https://fleet-reviews.com//fleet_review/api/web';